export default __webpack_public_path__ + "static/media/Muni3.e5a91202.jpg";